export default "__VITE_ASSET__Cf89s60o__"